import React, { useEffect } from "react";
import Logo from "../componets/Logo";

const TermsOfService: React.FC = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4 md:px-20">
      <Logo className="mb-8"/>
      <div className="max-w-4xl mx-auto bg-white shadow-md rounded-lg p-8">
        <h1 className="text-3xl font-bold mb-6 text-center">이용약관</h1>
        <p className="text-gray-600 mb-4 text-sm">시행일: 2025.08.25</p>

        {/* 목차 */}
        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">목차</h2>
          <ol className="list-decimal list-inside text-blue-600">
            <li>목적</li>
            <li>정의</li>
            <li>약관의 효력 및 변경</li>
            <li>회사의 지위 및 역할</li>
            <li>회원가입 및 계정관리</li>
            <li>서비스의 내용</li>
            <li>거래의 성립 및 표준보관계약</li>
            <li>호스트의 의무</li>
            <li>게스트의 의무</li>
            <li>금지물품</li>
            <li>책임, 보상한도 및 가액신고</li>
            <li>요금, 수수료 및 정산</li>
            <li>취소·해지·환불 및 분쟁처리</li>
            <li>장기미수령 및 유실물 처리</li>
            <li>금지행위</li>
            <li>리뷰·콘텐츠의 권리</li>
            <li>회사의 책임 제한</li>
            <li>개인정보보호</li>
            <li>약관 외 준칙</li>
            <li>준거법 및 재판관할</li>
          </ol>
        </div>

        {/* 약관 내용 */}
        <div className="space-y-6 text-gray-700 leading-relaxed">
          <section>
            <h3 className="font-semibold text-lg mb-1">제1조(목적)</h3>
            <p>이 약관은 ㈜로프(이하 “회사”)가 운영하는 빈 고(BIN GO) 플랫폼(웹/앱, 이하 “플랫폼”)을 통해 호스트와 게스트 간 보관(임치) 거래 및 부수 서비스를 중개함에 있어, 회사와 회원(호스트, 게스트 포함) 간 권리·의무, 이용조건 및 절차를 정함을 목적으로 합니다.</p>
          </section>

          <section>
            <h3 className="font-semibold text-lg mb-1">제2조(정의)</h3>
            <ol className="list-decimal list-inside">
              <li>“호스트”란 플랫폼에 보관공간 및 보관용역을 제공하는 자를 말합니다(수치인/보관자).</li>
              <li>“게스트”란 호스트에게 물건을 맡기는 자를 말합니다(임치인/위탁자).</li>
              <li>“중개서비스”란 회사가 플랫폼에서 거래 상대방 탐색·소통·결제 연계를 제공하는 통신판매중개 행위를 의미합니다.</li>
              <li>“보관거래”란 호스트와 게스트가 체결하는 임치(보관) 계약을 말합니다.</li>
              <li>“픽업/배송 연계”란 회원 간 합의 또는 제3자 운송사업자 이용으로 이루어지는 물품의 수거·인도 행위를 말합니다.(회사 직접 수행 아님을 원칙).</li>
            </ol>
          </section>

          <section>
            <h3 className="font-semibold text-lg mb-1">제3조(약관의 효력 및 변경)</h3>
            <ol className="list-decimal list-inside">
            <li>본 약관은 플랫폼에 게시하고 회원이 동의함으로써 효력이 발생합니다.</li>
            <li>회사는 관계법령을 위배하지 않는 범위에서 약관을 변경할 수 있으며, 변경 시 시행 7일 전(회원에게 불리하거나 중대한 사항은 30일 전)부터 공지합니다.</li>
            <li>회원이 변경약관 시행일 이후에도 서비스를 계속 이용하면 변경에 동의한 것으로 봅니다.</li>
            </ol>
          </section>

          <section>
            <h3 className="font-semibold text-lg mb-1">제4조(회사의 지위 및 역할)</h3>
            <ol className="list-decimal list-inside">
            <li>회사는 통신판매중개자로서 거래의 당사자가 아니며, 호스트와 게스트 사이의 보관거래 이행에 관한 법적 책임은 각 당사자에게 있습니다.</li>
            <li>회사는 플랫폼 운영, 정보제공, 결제 연계(전자지급결제대행사(PG) 연결) 및 분쟁조정 지원 등 중개·플랫폼 운영 업무를 수행합니다.</li>
            <li>회사가 별도로 직접 판매·보관을 명시한 경우에 한하여 해당 거래의 당사자가 됩니다.</li>
            </ol>
          </section>

          <section>
            <h3 className="font-semibold text-lg mb-1">제5조(회원가입 및 계정관리)</h3>
            <ol className="list-decimal list-inside">
            <li>회원은 실명·연락처 등 필수정보를 제공하고 약관에 동의하여 가입합니다. 필요한 경우 본인인증·연령확인·사업자등록 확인을 요청할 수 있습니다.</li>
            <li>계정 관리책임은 회원에게 있으며, 도용·무단사용 등으로 인한 손해는 회원의 과실에 기인한 경우 회원에게 귀속됩니다..</li>
            <li>허위정보 제공, 법령·약관 위반, 공공질서 침해 등 사유가 있는 경우 회사는 이용정지 또는 회원자격을 제한·해지할 수 있습니다.</li>
            </ol>
          </section>

          <section>
            <h3 className="font-semibold text-lg mb-1">제6조(서비스의 내용)</h3>
            <ol className="list-decimal list-inside space-y-2">
              <li>
                회사가 제공하는 서비스는 다음과 같습니다.
                <ol className="list-disc list-inside ml-5 mt-1 space-y-1">
                  <li>보관공간/보관용역 등록·검색·예약 중개</li>
                  <li>메시지/문의 등 거래 커뮤니케이션 도구</li>
                  <li>결제 연계(회사 지정 PG사 이용) 및 정산 지원</li>
                  <li>리뷰·평점 시스템 및 분쟁조정 절차 제공</li>
                  <li>기타 플랫폼 운영에 부수되는 일체</li>
                </ol>
              </li>
              <li>
              회사는 서비스 품질 향상 또는 법령 준수를 위해 서비스의 전부 또는 일부를 변경·중단할 수 있으며, 사전에 공지합니다. 긴급 장애·보안 등 불가피한 사유 시 사후 공지할 수 있습니다.
              </li>
            </ol>
          </section>

          <section>
            <h3 className="font-semibold text-lg mb-1">제7조(거래의 성립 및 표준보관계약의 편입)</h3>
            <ol className="list-decimal list-inside space-y-1">
              <li>게스트가 호스트의 고지정보(요금·기간·장소·보상한도·금지물품·인수방식 등)를 확인하고 예약·결제를 완료한 때에 보관거래가 성립합니다.</li>
              <li>호스트와 게스트 사이의 보관거래에는 본 약관에 첨부된 [별표 1] BIN GO 표준 보관거래 기본조건이 당연히 편입됩니다.</li>
              <li>호스트가 별도 개별조건을 제시하고 게스트가 이에 명시 동의한 경우, 개별조건이 표준조건에 우선합니다(단, 법령강행규정 및 약관규제법 위반 내용은 무효).</li>
              <li>픽업/배송은 회원 간 선택사항이며, 회사는 운송사업자·운송주선인 지위가 아닙니다. 운송 관련 위험과 책임은 당사자 또는 이용한 운송사업자에게 귀속됩니다.</li>
            </ol>
          </section>

          <section>
            <h3 className="font-semibold text-lg mb-1">제8조(호스트의 의무)</h3>
            <ol className="list-decimal list-inside space-y-1">
              <li>호스트는 (i) 사실·정확한 정보 제공, (ii) 건축물 용도·안전·소방 등 관계법령 준수, (iii) 금지물품 차단 및 안전관리, (iv) 합리적 인수·보관·반환 절차 운영, (v) 영수증·세금계산서 등 법정 발급의무를 이행해야 합니다.</li>
              <li>보관물 멸실·훼손이 발생하지 않도록 선량한 관리자의 주의의무를 다해야 하며, 고의 또는 중대한 과실로 인한 손해에 대해 책임을 부담합니다(제11조, 별표 1 참조).</li>
              <li>게스트의 정당한 반환청구에 응해야 하며, 미수금·장기미수령 등은 별표 1의 절차(적법한 통지·유예·처리)에 따라야 합니다.</li>
            </ol>
          </section>

          <section>
            <h3 className="font-semibold text-lg mb-1">제9조(게스트의 의무)</h3>
            <ol className="list-decimal list-inside space-y-1">
              <li>게스트는 (i) 물품의 종류·수량·가액·상태에 관한 정확한 고지, (ii) 안전·파손 방지를 위한 적정 포장, (iii) 금지물품 미반입, (iv) 약정한 기간 내 반출·대금지급을 이행해야 합니다.</li>
              <li>위법물품·위험물 반입 또는 허위신고, 부적정 포장 등 게스트 귀책으로 인한 손해는 게스트가 부담합니다(고의·중과실 여부 불문, 제3자 피해 발생 시 관련 법령 적용).</li>
            </ol>
          </section>

          <section>
            <h3 className="font-semibold text-lg mb-1">제10조(금지물품)</h3>
            <ol className="list-decimal list-inside space-y-1">
              <li>총포·도검·폭발물·마약 등 불법물품, 「위험물안전관리법」상 지정수량 해당 위험물, 가연성 고위험 물질, 현금·유가증권·귀금속(신고 없는 경우), 동물·생물, 부패·오염 우려물 등은 원칙적으로 보관할 수 없습니다.</li>
              <li>호스트는 별도 시설·허가·보험 등 요건을 갖춘 경우에 한해 예외적으로 취급할 수 있으며, 이 경우 이를 명시 고지하고 법령을 준수해야 합니다.</li>
            </ol>
          </section>

          <section>
            <h3 className="font-semibold text-lg mb-1">제11조(책임, 보상한도 및 가액신고)</h3>
            <ol className="list-decimal list-inside space-y-1">
              <li>호스트의 고의 또는 중대한 과실로 인한 손해에 대하여 호스트는 민법·상법 등 관계 법령에 따라 배상책임을 부담합니다.</li>
              <li>그 외 통상의 과실 영역에서는 [별표 1]의 기본 보상한도가 적용되며, 게스트가 가액신고 또는 추가보상옵션을 선택한 경우에는 약정한 한도 내에서 배상합니다.</li>
              <li>게스트가 물품의 내용·가액을 허위·누락 신고하거나 금지물품을 반입한 경우에는 호스트의 책임이 제한·면제될 수 있습니다(고의·중과실 제외).</li>
            </ol>
          </section>

          <section>
            <h3 className="font-semibold text-lg mb-1">제12조(요금, 수수료 및 정산)</h3>
            <ol className="list-decimal list-inside space-y-1">
              <li>게스트는 보관료·부대비용(보안씰·포장재·추가관리요금 등)을 결제하고, 회사는 플랫폼 수수료를 공제한 후 호스트에게 정산합니다.</li>
              <li>결제는 회사 지정 PG사를 통해 처리되며, 결제취소·환불·부분환불 등은 전자상거래법·PG 규정 및 본 약관·별표 1에 따릅니다.</li>
              <li>부가가치세 등 세무상 책임은 공급자인 호스트에게 귀속됩니다(회사가 세금계산서 발급주체인 경우 별도 고지).</li>
            </ol>
          </section>

          <section>
            <h3 className="font-semibold text-lg mb-1">제13조(취소·해지·환불 및 분쟁처리)</h3>
            <ol className="list-decimal list-inside space-y-1">
              <li>보관개시 전 취소: 호스트 정책에 따르되, 소비자 보호취지에 반하지 않는 합리적 기준을 사전 고지해야 합니다.</li>
              <li>보관개시 후 해지: 이미 발생한 보관료 및 비용은 정산하고, 반환·회수 절차는 별표 1에 따릅니다.</li>
              <li>분쟁 발생 시 (i) 당사자 협의 → (ii) 플랫폼 분쟁조정 지원 → (iii) 관할 기관 조정/소송 순으로 처리합니다.</li>
            </ol>
          </section>

          <section>
            <h3 className="font-semibold text-lg mb-1">제14조(장기미수령 및 유실물 처리)</h3>
            <p>게스트가 약정기간 경과 후에도 물품을 인수하지 않거나 요금을 연체하는 경우, 호스트는 적법한 통지(2회 이상 전자우편/문자 등)와 유예기간(최소 14일)을 부여한 뒤, 민법 등 관계법령에 따른 유치권 행사·처분(경매·폐기 등)을 할 수 있습니다. 구체 절차는 [별표 1]에 따릅니다.</p>
          </section>

          <section>
            <h3 className="font-semibold text-lg mb-1">제15조(금지행위)</h3>
            <ol className="list-decimal list-inside space-y-1">
              <li>법령·본 약관 위반, 허위·괴담 유포, 타인 권리침해, 시스템 해킹·스크래핑, 리뷰조작, 부정 취득한 혜택 사용 등은 금지합니다.</li>
              <li>회사는 금지행위에 대해 게시중단, 이용정지, 계약해지, 손해배상 청구 등 필요한 조치를 할 수 있습니다.</li>
            </ol>
          </section>

          <section>
            <h3 className="font-semibold text-lg mb-1">제16조(리뷰·콘텐츠의 권리)</h3>
            <p>회원이 작성한 리뷰·사진·설명 등 콘텐츠의 저작권은 원저작자에게 귀속되나, 회원은 회사에 서비스 운영·홍보 목적의 비독점적 사용권을 무상·영속적으로 허여합니다(개인정보 제외).</p>
          </section>

          <section>
            <h3 className="font-semibold text-lg mb-1">제17조(회사의 책임 제한)</h3>
            <ol className="list-decimal list-inside space-y-1">
              <li>회사는 중개자로서 거래당사자 간 보관이행·물품 상태·법령준수 등에 대해 보증하지 않습니다.</li>
              <li>다만 회사의 고의 또는 중대한 과실로 인한 손해에 대하여는 책임을 부담합니다.</li>
              <li>불가항력(천재지변, 정전, 통신장애 등)으로 인한 서비스 중단에 대하여 회사는 책임을 지지 않습니다.</li>
            </ol>
          </section>

          <section>
            <h3 className="font-semibold text-lg mb-1">제18조(개인정보보호)</h3>
            <p>회사는 개인정보보호법 등 관계법령에 따라 개인정보 처리방침을 별도로 수립·공개하며, 회원의 개인정보를 적법·안전하게 처리합니다.</p>
          </section>

          <section>
            <h3 className="font-semibold text-lg mb-1">제19조(약관 외 준칙)</h3>
            <p>본 약관에 정하지 않은 사항은 전자상거래법, 소비자기본법, 민법·상법, 약관규제법 등 관계법령 및 일반 상관례를 따릅니다.</p>
          </section>

          <section>
            <h3 className="font-semibold text-lg mb-1">제20조(준거법 및 재판관할)</h3>
            <p>본 약관은 대한민국 법률을 준거법으로 하며, 서비스 이용과 관련한 분쟁은 민사소송법상 관할법원을 합의관할로 합니다.</p>
          </section>

          {/* 예시로 마지막 부칙 */}
          <section>
            <h3 className="font-semibold text-lg mb-1">부칙</h3>
            <p>1. 시행일: 2025. 08. 25.</p>
            <p>2. 본 약관은 시행일 이후 체결되는 모든 거래에 적용됩니다.</p>
          </section>
        </div>

        {/* 홈 버튼 */}
        <div className="text-center mt-8">
          <a
            href="/"
            className="inline-block bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 transition"
          >
            홈으로 이동
          </a>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
